import { HabiLeadsSellers } from 'src/components/HabiLeadsSellers';
import { Layout } from 'src/components/layout/layout';

const HabiLeadsSellersPage = () => {
    return (
        <Layout>
            <HabiLeadsSellers />
        </Layout>
    );
};

export default HabiLeadsSellersPage;
